
import { ComplianceDocument } from '@/types/compliance';

export const complianceDocuments: ComplianceDocument[] = [
  {
    id: '1',
    name: 'Payment Card Industry Data Security Standard (PCI DSS)',
    content: [
      "This is page 1 of the document. It contains important compliance information.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia.",
      "This is page 2 of the document. It contains important compliance information.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia.",
      "This is page 3 of the document. It contains important compliance information.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia."
    ],
    rules: [
      {
        id: '2.1',
        title: 'Rule 2.1: Build and Maintain Secure Networks',
        description: 'Install and maintain a firewall configuration to protect cardho',
        status: 'breached'
      },
      {
        id: '2.2',
        title: 'Rule 2.2: Protect Cardholder Data',
        description: 'Encrypt transmission of cardholder data across open, public',
        status: 'breached'
      },
      {
        id: '2.3',
        title: 'Rule 2.3: Maintain Vulnerability Management',
        description: 'Use and regularly update anti-virus software on all systems.',
        status: 'compliant'
      }
    ]
  },
  {
    id: '2',
    name: 'RBI Digital Lending Guidelines',
    content: [
      "This document outlines RBI's digital lending guidelines.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget justo vel nunc tempus lacinia.",
      "Page 2 describes technical requirements for digital lending.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Final page discusses compliance monitoring procedures.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit."
    ],
    rules: [
      {
        id: '1.1',
        title: 'Rule 1.1: Direct Disbursement to Borrowers',
        description: 'Ensure all loan disbursals are made directly to the borrower\'s bank account',
        status: 'compliant'
      },
      {
        id: '1.2',
        title: 'Rule 1.2: Transparent Disclosure',
        description: 'Disclose all fees, charges, and interest rates to borrowers in a standardized format',
        status: 'compliant'
      },
      {
        id: '1.3',
        title: 'Rule 1.3: Algorithmic Fairness',
        description: 'Ensure lending algorithms don\'t discriminate based on protected characteristics',
        status: 'breached'
      }
    ]
  }
];
